export class BackupJob {
    'jobExecutionDetails';
    'resourceDetails';
    'snapshotDetails';
    'backupType';
    'vault';
    'backupPolicyId';
    'cloudSnapshotIds';
    'steps';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobExecutionDetails",
            "baseName": "jobExecutionDetails",
            "type": "JobExecutionDetails",
            "format": ""
        },
        {
            "name": "resourceDetails",
            "baseName": "resourceDetails",
            "type": "ResourceDetails",
            "format": ""
        },
        {
            "name": "snapshotDetails",
            "baseName": "snapshotDetails",
            "type": "JobSnapshotDetails",
            "format": ""
        },
        {
            "name": "backupType",
            "baseName": "backupType",
            "type": "BackupJobType",
            "format": ""
        },
        {
            "name": "vault",
            "baseName": "vault",
            "type": "BackupVault",
            "format": ""
        },
        {
            "name": "backupPolicyId",
            "baseName": "backupPolicyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudSnapshotIds",
            "baseName": "cloudSnapshotIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "steps",
            "baseName": "steps",
            "type": "Array<JobStep>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupJob.attributeTypeMap;
    }
    constructor() {
    }
}
